import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import type { ApprovalsFilters } from '@/features/approvals-inbox/api'
import { ApprovalsInboxScreen } from '@/features/approvals-inbox/inbox-screen'
import { approvalsAccessQuery } from '@/lib/approvals-access'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/approvals')({
  validateSearch: (search: Record<string, unknown>): ApprovalsFilters => ({
    search: typeof search.search === 'string' ? search.search : undefined,
    type: typeof search.type === 'string' ? search.type : undefined,
    from: typeof search.from === 'string' ? search.from : undefined,
    to: typeof search.to === 'string' ? search.to : undefined,
    view: search.view === 'all' ? 'all' : undefined,
    open: typeof search.open === 'string' ? search.open : undefined,
  }),
  beforeLoad: async ({ context }) => {
    if (hasGrant(context.queryClient, 'approval.view')) return
    // A direct manager or a path approver without the grant: the server knows.
    if (!(await context.queryClient.ensureQueryData(approvalsAccessQuery))) {
      throw redirect({ to: '/' })
    }
  },
  component: ApprovalsRoute,
})

function ApprovalsRoute() {
  const navigate = useNavigate()
  const params = Route.useSearch()
  return (
    <ApprovalsInboxScreen
      params={params}
      onParamsChange={(next) => void navigate({ to: '/approvals', search: next, replace: true })}
    />
  )
}
